export enum MilaSender {
  Mila = 'Mila',
  Contact = 'Contact'
}

export interface MilaMessage {
  time: string;
  sender: MilaSender;
  message: string;
}

export interface MilaCase {
  caseId: string;
  caseOutcome: string;
  caseType: string;
  timeOfCompletion: string;
  timeOfCreation?: string;
  contactId: number;
  messages: MilaMessage[];
  communicationChannel: 'CHAT' | 'VOICE' | 'EMAIL' | string;
  summary?: string;
  notes?: string;
}

export interface PatientCase {
  caseId: string;
  caseOutcome: string;
  caseType: string;
  status: 'CLOSED' | 'CRITICAL' | 'COMPLETED' | 'FAILED' | null;
  communicationChannel: MilaCase['communicationChannel'];
  timeOfCompletion: string | null;
  timeOfCreation: string;
}
